import "core-js/modules/es6.weak-map";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.map";
import _slicedToArray from "/Users/muhammadmateen/Desktop/work/onechange/1Change-App/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import { dropUndefinedKeys } from '@sentry/utils';
import '../debug-build.js';
import '../tracing/errors.js';
import '../tracing/spanstatus.js';
import { getActiveSpan } from '../tracing/trace.js';
/**
 * key: bucketKey
 * value: [exportKey, MetricSummary]
 */

var SPAN_METRIC_SUMMARY;

function getMetricStorageForSpan(span) {
  return SPAN_METRIC_SUMMARY ? SPAN_METRIC_SUMMARY.get(span) : undefined;
}
/**
 * Fetches the metric summary if it exists for the passed span
 */


function getMetricSummaryJsonForSpan(span) {
  var storage = getMetricStorageForSpan(span);

  if (!storage) {
    return undefined;
  }

  var output = {};
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = storage[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _step$value = _slicedToArray(_step.value, 2),
          _step$value$ = _slicedToArray(_step$value[1], 2),
          exportKey = _step$value$[0],
          summary = _step$value$[1];

      if (!output[exportKey]) {
        output[exportKey] = [];
      }

      output[exportKey].push(dropUndefinedKeys(summary));
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator["return"] != null) {
        _iterator["return"]();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return output;
}
/**
 * Updates the metric summary on the currently active span
 */


function updateMetricSummaryOnActiveSpan(metricType, sanitizedName, value, unit, tags, bucketKey) {
  var span = getActiveSpan();

  if (span) {
    var storage = getMetricStorageForSpan(span) || new Map();
    var exportKey = "".concat(metricType, ":").concat(sanitizedName, "@").concat(unit);
    var bucketItem = storage.get(bucketKey);

    if (bucketItem) {
      var _bucketItem = _slicedToArray(bucketItem, 2),
          summary = _bucketItem[1];

      storage.set(bucketKey, [exportKey, {
        min: Math.min(summary.min, value),
        max: Math.max(summary.max, value),
        count: summary.count += 1,
        sum: summary.sum += value,
        tags: summary.tags
      }]);
    } else {
      storage.set(bucketKey, [exportKey, {
        min: value,
        max: value,
        count: 1,
        sum: value,
        tags: tags
      }]);
    }

    if (!SPAN_METRIC_SUMMARY) {
      SPAN_METRIC_SUMMARY = new WeakMap();
    }

    SPAN_METRIC_SUMMARY.set(span, storage);
  }
}

export { getMetricSummaryJsonForSpan, updateMetricSummaryOnActiveSpan };